/** Programmatic save of a Blob using a temporary object URL (browser download). */
export function triggerBlobDownload(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    a.remove();
    queueMicrotask(() => URL.revokeObjectURL(url));
}
